import { smoothScroll } from './smooth-scroll';

export function initFaqAnchor() : void {
    const $faq = document.querySelector<HTMLElement>('.js-faq');

    if ($faq) {
        new FaqAnchor($faq);
    }
}

class FaqAnchor {
    $container: HTMLElement;
    $categories: NodeListOf<HTMLElement>;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$categories = this.$container.querySelectorAll<HTMLElement>('.js-faq-category');

        const params = new URL(location.href).searchParams;
        const categoryIndex = params.get('category');
        const subcategorySlug = params.get('subcategory') as string;
        const questionSlug = params.get('question');

        if (questionSlug) {
            this.openQuestionBySlug(questionSlug);
        } else if (categoryIndex) {
            this.openCategoryByIndex(parseInt(categoryIndex), subcategorySlug);
        } else {
            this.openFirstCategory();
        }
    }

    /**
     * Open category by its index and his subcategory
     * 
     * @param {number} categoryIndex 
     * @param {string} subcategorySlug 
     * 
     * @return {void}
     */
    openCategoryByIndex(categoryIndex: number, subcategorySlug: string) : void {
        this.$categories.forEach(($category, index) => {
            if (index === categoryIndex) {
                $category.classList.add('tab-active');
                $category.querySelector('input')?.removeAttribute('checked');

                if (subcategorySlug) {
                    const $subcategory = $category.querySelector<HTMLElement>(`.js-faq-subcategory[data-slug="${encodeURI(subcategorySlug.toLowerCase())}"]`);
                    if ($subcategory) {
                        $subcategory.click();
                    }
                } else {
                    $category.querySelector<HTMLElement>('.js-faq-subcategory')?.click();
                }
            } else {
                $category.classList.remove('tab-active');
                $category.querySelector<HTMLInputElement>('input')?.setAttribute('checked', 'checked');
            }
        });
    }

    /**
     * Open a question by his slug
     * 
     * @param {string} questionSlug 
     * 
     * @return {void}
     */
    openQuestionBySlug(questionSlug: string) : void {
        const $question = this.$container.querySelector<HTMLElement>(`.js-faq-question[data-slug="${encodeURI(questionSlug)}"],.js-faq-question[data-id="${questionSlug}"]`);

        if ($question) {
            $question.querySelector<HTMLLabelElement>('label')?.click();
            this.openCategoryQuestion($question);
            this.scrollToQuestion($question);
        }
    }

    /**
     * Open the category of a question
     * 
     * @param {HTMLElement} $question 
     * 
     * @return {void}
     */
    openCategoryQuestion($question: HTMLElement) : void {
        const subCategoryQuestion = ($question.parentNode as HTMLElement).dataset.tabName as string;
        const categoryQuestionAccordeonId = `#chck-nav-${subCategoryQuestion?.substring(14, 15)}`;
        const $categoryQuestionAccordeon = this.$container.querySelector<HTMLInputElement>(categoryQuestionAccordeonId);

        if ($categoryQuestionAccordeon) {
            $categoryQuestionAccordeon.checked = false;
        }

        this.forceChangeTab(subCategoryQuestion);
    }

    /**
     * Open the first category by default
     * 
     * @return {void}
     */
    openFirstCategory() : void {
        const categoryQuestionAccordeonId = `#chck-nav-0`;
        const $categoryQuestionAccordeon = this.$container.querySelector<HTMLInputElement>(categoryQuestionAccordeonId);

        if ($categoryQuestionAccordeon) {
            $categoryQuestionAccordeon.checked = false;
        }
    }

    /**
     * Change tab by its name
     * 
     * @param {string} tabName 
     * 
     * @return {void}
     */
    forceChangeTab(tabName: string) : void {
        const $tabContents = this.$container.querySelectorAll<HTMLElement>('.js-tab-content');
        const $tabButtons = this.$container.querySelectorAll<HTMLElement>('.js-tab-button');

        $tabContents.forEach($content => {
            if (tabName === $content.dataset.tabName) {
                $content.classList.add('tab-active');
            } else {
                $content.classList.remove('tab-active');
            }
        });

        $tabButtons.forEach($button => {
            if (tabName === $button.dataset.tabName) {
                $button.classList.add('tab-active');
            } else {
                $button.classList.remove('tab-active');
            }
        });
    }

    /**
     * Scroll to a question Element
     * 
     * @param {HTMLElement} $question 
     * 
     * @return {void}
     */
    scrollToQuestion($question: HTMLElement) : void {
        smoothScroll($question, true);
    }
}
